import React, { Component } from 'react';
import Feeds from '../../home/components/Feeds';
import { GaContext } from '../../../googleAnalyticsContext/GaContext';
import PropTypes from 'prop-types';
import { Loader, NoTopic } from '../../shared-components';
import { convertEstimationTimeStringFromHours } from '../../home/sharedFunctions';


class TopicPreview extends Component {
  static propTypes = {
    topicPreviewPosts:                          PropTypes.array.isRequired,
    topicPreviewTotalPostsCount:                PropTypes.number,
    topicPreviewTotalCommentsCount:             PropTypes.number,
    topicPreviewEstimatedProcessingTimeInHours: PropTypes.number,
    retrieveTopicPreviewBegin:                  PropTypes.bool.isRequired,
    retrieveTopicPreviewSuccess:                PropTypes.bool.isRequired,
    retrieveTopicPreviewFailure:                PropTypes.bool.isRequired,
    topicKeywordsJSON:                          PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      topicPreviewPosts:                          [],
      topicPreviewTotalPostsCount:                null,
      topicPreviewTotalCommentsCount:             null,
      topicPreviewEstimatedProcessingTimeInHours: null,
      retrieveTopicPreviewBegin:                  false,
      retrieveTopicPreviewSuccess:                false,
      retrieveTopicPreviewFailure:                false,
      topicKeywordsJSON:                          {}
    };
  }

  static contextType =GaContext
  componentDidMount() {
    const {ReactGA} = this.context;
    ReactGA.pageview('/dashboard/topics/topicPreview');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._setRetrieveTopicPreviewBeginToStateIfNeeded(nextProps);
    this._setRetrieveTopicPreviewSuccessToStateIfNeeded(nextProps);
    this._setRetrieveTopicPreviewFailureToStateIfNeeded(nextProps);
    this._setPostsToStateIfNeeded(nextProps);
    this._setTopicPreviewTotalPostsCountToStateIfNeeded(nextProps);
    this._setTopicPreviewTotalCommentsCountToStateIfNeeded(nextProps);
    this._setTopicPreviewEstimatedProcessingTimeInHoursToStateIfNeeded(nextProps);
    this._setTopicKeywordsJSONToStateIfNewTopicKeywordsJSON(nextProps);
  }

  _setPostsToStateIfNeeded(nextProps) {
    if (JSON.stringify(nextProps.topicPreviewPosts) !== JSON.stringify(this.state.topicPreviewPosts)) {
      this.setState({topicPreviewPosts: nextProps.topicPreviewPosts});
    }
  }

  _setTopicPreviewTotalPostsCountToStateIfNeeded(nextProps) {
    if (JSON.stringify(nextProps.topicPreviewTotalPostsCount) !== JSON.stringify(this.state.topicPreviewTotalPostsCount)) {
      this.setState({topicPreviewTotalPostsCount: nextProps.topicPreviewTotalPostsCount});
    }
  }

  _setTopicPreviewTotalCommentsCountToStateIfNeeded(nextProps) {
    if (JSON.stringify(nextProps.topicPreviewTotalCommentsCount) !== JSON.stringify(this.state.topicPreviewTotalCommentsCount)) {
      this.setState({topicPreviewTotalCommentsCount: nextProps.topicPreviewTotalCommentsCount});
    }
  }

  _setTopicPreviewEstimatedProcessingTimeInHoursToStateIfNeeded(nextProps) {
    if (JSON.stringify(nextProps.topicPreviewEstimatedProcessingTimeInHours) !== JSON.stringify(this.state.topicPreviewEstimatedProcessingTimeInHours)) {
      this.setState({topicPreviewEstimatedProcessingTimeInHours: nextProps.topicPreviewEstimatedProcessingTimeInHours});
    }
  }

  _setRetrieveTopicPreviewBeginToStateIfNeeded(nextProps){
    if (nextProps.retrieveTopicPreviewBegin !== this.state.retrieveTopicPreviewBegin) {
      this.setState({ retrieveTopicPreviewBegin: nextProps.retrieveTopicPreviewBegin });
    }
  }

  _setRetrieveTopicPreviewSuccessToStateIfNeeded(nextProps){
    if (nextProps.retrieveTopicPreviewSuccess !== this.state.retrieveTopicPreviewSuccess) {
      this.setState({ retrieveTopicPreviewSuccess: nextProps.retrieveTopicPreviewSuccess });
    }
  }

  _setRetrieveTopicPreviewFailureToStateIfNeeded(nextProps) {
    if (nextProps.retrieveTopicPreviewFailure !== this.state.retrieveTopicPreviewFailure) {
      this.setState({ retrieveTopicPreviewFailure: nextProps.retrieveTopicPreviewFailure });
    }
  }

  _setTopicKeywordsJSONToStateIfNewTopicKeywordsJSON(nextProps) {
    if (JSON.stringify(nextProps.topicKeywordsJSON) !== JSON.stringify(this.state.topicKeywordsJSON)) {
      this.setState({topicKeywordsJSON: nextProps.topicKeywordsJSON});
    }
  }

  _returnEstimationTimeString() {
    const { topicPreviewEstimatedProcessingTimeInHours } = this.state;
    const [numberOfDays, numberOfHours, numberOfMinutes] = convertEstimationTimeStringFromHours(topicPreviewEstimatedProcessingTimeInHours);
    const estimatedTimeString = `${numberOfDays} days ${numberOfHours} hrs ${numberOfMinutes} mins`;
    return estimatedTimeString;
  }

  render() {
    const estimatedTimeString = this._returnEstimationTimeString();
    return (
      <span>
        <div className="topic-preview-header">
          <h4 className="topic-preview-title">Estimation & Posts Preview</h4>
        </div>
        {this.state.retrieveTopicPreviewSuccess && (
          <div className="topic-preview-estimation">
            <div className="preview-estimation-text-container">
              <span>
                <i className="la la-clock-o icon"></i> Estimated processing time: {estimatedTimeString}
              </span>
            </div>
            <div className="preview-estimation-text-container">
              <span>
                Found <b>{this.state.topicPreviewTotalPostsCount}</b> matching <b>posts</b> and 
                <b> {this.state.topicPreviewTotalCommentsCount}</b> matching <b>comments</b>.
              </span>
            </div>
            <div className="preview-estimation-text-container number-of-posts-text">
              <span>
                Showing <b>{this.state.topicPreviewPosts.length}</b> most recent posts.
              </span>
            </div>
          </div>
        )}
        {this.state.retrieveTopicPreviewSuccess  &&  (
          <div className="topic-preview-body">
            <div className={`feed-comments`}>
              {this.state.topicPreviewPosts.map((post, index) => (
                <Feeds
                  feed={post}
                  key={index}
                  topicKeywordsJSON={this.state.topicKeywordsJSON}
                  isTopicPreview={true}
                  isHarmWatchTab={false}
                />
              ))}
            </div>
          </div>
        )}
        {this.state.retrieveTopicPreviewBegin && (
          <div>
            <div className="row" style={{ 'height': '250px' }}/>
            <div className="row">
              <div className="col-sm-5"/>
              <div className="col-sm-2"><Loader /></div>
              <div className="col-sm-5"/>
            </div>
          </div>
        )}
        {! this.state.retrieveTopicPreviewSuccess && ! this.state.retrieveTopicPreviewBegin &&  (
          <div className="topic-preview-body" >
            <NoTopic
              title="It’s Empty"
              message="Enter topic info and press the Preview button to see a preview of the results here."
              icons={['rss-square']}
            >
            </NoTopic>
          </div>
        )}
      </span>
    );
  }
}

export default TopicPreview;


// WEBPACK FOOTER //
// ./src/features/topics/components/TopicPreview.js